var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCloseRed = function SvgCloseRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9706 16.2425L12.6441 12.036C12.5197 11.915 12.3478 11.8402 12.1581 11.8402C11.7779 11.8402 11.4706 12.139 11.4706 12.5086C11.4706 12.6931 11.5476 12.8602 11.672 12.9812L15.9985 17.1877L11.672 21.3941C11.5476 21.5151 11.4706 21.6822 11.4706 21.8667C11.4706 22.2364 11.7779 22.5352 12.1581 22.5352C12.3478 22.5352 12.5197 22.4603 12.6441 22.3393L16.9706 18.1328L21.297 22.3393C21.4215 22.4603 21.5933 22.5352 21.7831 22.5352C22.1626 22.5352 22.4706 22.2364 22.4706 21.8667C22.4706 21.6822 22.3936 21.5151 22.2691 21.3941L17.9427 17.1877L22.2691 12.9812C22.3936 12.8602 22.4706 12.6931 22.4706 12.5086C22.4706 12.139 22.1626 11.8402 21.7831 11.8402C21.5933 11.8402 21.4215 11.915 21.297 12.036L16.9706 16.2425Z",
    fill: "#ED1C24",
    stroke: "#ED1C24"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-red.7b79efa7.svg";
export { ForwardRef as ReactComponent };